import AppBase from './AppBase';
import PushpinsControl from './services/lmv/pushpins-control';
import {MOCK_ISSUE_TYPE} from './constants/issue-types';
import {viewTypes} from './constants/view-types';

import {enablePushpinWorkflowAction} from './app/actions';

export default class extends AppBase {
  constructor(...args) {
    super(...args);
    // MOCK_ISSUE_TYPE is a placeholder used to allow the app to load
    // (it won't display the panel until an actual issue type is set)
    this.defaultRoute = `/${MOCK_ISSUE_TYPE}`;
    this.viewType = viewTypes.DOCUMENT;
  }

  configureExternalControls() {
    this.pushpinsControl = new PushpinsControl();
  }

  setPushpinExtension(pushpinExtension) {
    if (pushpinExtension && pushpinExtension.updatePattern) {
      // Add "quality issues" statuses to "issues" type pushpins -
      // in unified issues all "quality_issues" pushpins will have "issues" type
      pushpinExtension.updatePattern('issues-not_approved', 80, '#ff495c');
      pushpinExtension.updatePattern('issues-not_approved-selected', 80, '#ff495c');
      pushpinExtension.updatePattern('issues-not_approved-movable', 80, '#ff495c');

      pushpinExtension.updatePattern('issues-ready_to_inspect', 80, '#7a77d9');
      pushpinExtension.updatePattern('issues-ready_to_inspect-selected', 80, '#7a77d9');
      pushpinExtension.updatePattern('issues-ready_to_inspect-movable', 80, '#7a77d9');

      pushpinExtension.updatePattern('issues-work_completed', 80, '#087cd9');
      pushpinExtension.updatePattern('issues-work_completed-selected', 80, '#087cd9');
      pushpinExtension.updatePattern('issues-work_completed-movable', 80, '#087cd9');

      pushpinExtension.updatePattern('issues-in_dispute', 80, '#ff495c');
      pushpinExtension.updatePattern('issues-in_dispute-selected', 80, '#ff495c');
      pushpinExtension.updatePattern('issues-in_dispute-movable', 80, '#ff495c');

      pushpinExtension.updatePattern('issues-void', 80, '#bcc9d1');
      pushpinExtension.updatePattern('issues-void-selected', 80, '#bcc9d1');
      pushpinExtension.updatePattern('issues-void-movable', 80, '#bcc9d1');
    }

    this.pushpinsControl.setPushpinExtension(pushpinExtension);
  }

  enablePushpinWorkflow() {
    this.store.dispatch(enablePushpinWorkflowAction(true));
  }

  disablePushpinWorkflow() {
    this.store.dispatch(enablePushpinWorkflowAction(false));
  }
}
